interface OverdueWorkOrder {
    isOverdue?: boolean | null;
    daysOverdue?: number | null;
}

/**
 * A work order shows the amber "Overdue" banner when the backend flags it overdue
 * (WorkOrder::isOverdue — past its due date and not done). The backend value is
 * authoritative so the board, dashboard and notifications all agree on one threshold.
 */
export const workOrderIsOverdue = (workOrder: OverdueWorkOrder | null | undefined): boolean => {
    return workOrder?.isOverdue === true;
};

/** Whole days past due, used for the banner chip; 0 (falsy) hides the chip. */
export const workOrderDaysOverdue = (workOrder: OverdueWorkOrder | null | undefined): number => {
    return workOrder?.daysOverdue ?? 0;
};
